import styled, { css } from 'styled-components';
import { plainTextStyle } from '@westwing/ui-kit/typography';

export const StyledFilterLabel = styled.label<{ hasErrors?: boolean }>`
    ${plainTextStyle}
    padding-left: 10px;
    width: 100%;
    ${({ hasErrors, theme }) =>
        hasErrors &&
        css`
            color: ${theme.colors.red90};
        `}
`;

export const textEllipsisCss = css`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const textLinesLimitClipCss = (maxLineCount: number) => css`
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: ${maxLineCount};
    -webkit-box-orient: vertical;
`;

export const textLinesLimitEllipsisCss = (maxLineCount: number) => css`
    ${textLinesLimitClipCss(maxLineCount)}
    text-overflow: ellipsis;
`;
